import { Controller } from "@hotwired/stimulus"
import { useIntersection, useVisibility } from "stimulus-use"

export default class extends Controller {
  static targets = ["button"]
  static scrollInterval = null
  // <li class="send-msg" data-controller='message-chat' data-message-chat-member-profile-id='<%= message.member_profile.id %>' hidden>
  // this is called whenever we load message from initial html or when it is
  // appended with turbo stream

  connect() {
    // Show the message and apply right-aligned class if sender
    this.showMessageAndAddClassMessageRighted()

    // Scroll chat container to bottom (debounced across all message instances)
    this.scrollChatToBottom()

    // Initialize intersection & visibility observers
    useIntersection(this)
    useVisibility(this)
  }

  disconnect() {
    if (this.constructor.scrollInterval) {
      clearInterval(this.constructor.scrollInterval)
      this.constructor.scrollInterval = null
    }
  }

  showMessageAndAddClassMessageRighted() {
    if (this.isSender()) this.element.classList.add("message--righted")
    this.element.hidden = false
  }

  isSender() {
    return this.currentMemberProfileId == this.memberProfileId
  }

  get currentMemberProfileId() {
    return document.querySelector("[name=current-member-profile-id]").content
  }

  get memberProfileId() {
    return this.data.get("memberProfileId")
  }

  get readAt() {
    return this.data.get("readAt")
  }

  set readAt(value) {
    this.element.setAttribute("data-message-chat-read-at", value)
  }

  /**
   * Scroll the entire chat container to the bottom.
   * Uses a single shared interval across all message instances to avoid
   * creating N concurrent timers when N messages connect simultaneously.
   */
  scrollChatToBottom() {
    const container = this.element.closest(".chats")
    if (!container) return

    // Clear any existing scroll interval so only the last message triggers it
    if (this.constructor.scrollInterval) {
      clearInterval(this.constructor.scrollInterval)
    }

    // Keep trying until scrollHeight stops changing (all messages rendered)
    let lastScrollHeight = 0
    this.constructor.scrollInterval = setInterval(() => {
      if (container.scrollHeight !== lastScrollHeight) {
        lastScrollHeight = container.scrollHeight
        container.scrollTop = container.scrollHeight
      } else {
        clearInterval(this.constructor.scrollInterval)
        this.constructor.scrollInterval = null
      }
    }, 50)
  }

  /**
   * Called when message enters viewport
   * Marks unread messages as read
   */
  appear(entry) {
    if (this.isSender()) return // sender doesn't mark as read
    if (this.readAt != "") return // already read
    if (this.pageNotVisible) return // tab not active

    if (this.hasButtonTarget) this.buttonTarget.click()
    this.readAt = "updated"
  }

  dissapear(entry) {
  }

  visible() {
    this.pageNotVisible = false
  }

  invisible() {
    this.pageNotVisible = true
  }
}
